import { render } from "./icon-reviewed-not-by-you-counter-4+.svg?vue&type=template&id=e120b28e&scoped=true&component"
const script = {}

import "./icon-reviewed-not-by-you-counter-4+.svg?vue&type=style&index=0&id=e120b28e&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e120b28e"]])

export default __exports__